<ng-container *ngIf="permConfig.isViewAllowed">
<div class="container-fluid">
    <app-page-title title="Asset Management"></app-page-title>
    <div [formGroup]="assetForm">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label for="assetType" class="form-label">Type<span class="mandatory">*</span></label>
                                    <ng-select #assetType id="assetType" [items]="assetTypeList" bindLabel="name" (change)="onAssetsChange()"
                                        placeholder="Select" [bindValue]="'value'" [appendTo]="'body'" [openOnEnter]="false"
                                        formControlName="ddlAssetType"
                                        class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || assetForm.get('ddlAssetType').touched) && assetForm.get('ddlAssetType').errors}" 
                                        (keydown.enter)="useEnterKey && assetForm.get('ddlAssetType').valid ? serviceCenter.focus() : assetForm.get('ddlAssetType').markAsTouched()">
                                    </ng-select>
                                    <div *ngIf="(isFormSubmitted || assetForm.get('ddlAssetType').touched) && assetForm.get('ddlAssetType').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="assetForm.get('ddlAssetType').errors.required">Type is
                                            Required</span>
                                    </div>

                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="mb-2">
                                    <label for="serviceCenter" class="form-label">Service Center<span
                                            class="mandatory">*</span></label>
                                    <ng-select #serviceCenter id="serviceCenter" [items]="serviceCenterList" bindLabel="name"
                                        placeholder="Select" [bindValue]="'id'" [appendTo]="'body'" [openOnEnter]="false"
                                        formControlName="ddlServiceCenter"
                                        class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || assetForm.get('ddlServiceCenter').touched) && assetForm.get('ddlServiceCenter').errors}" 
                                        (keydown.enter)="useEnterKey && assetForm.get('ddlServiceCenter').valid ? conditionalFocus() : assetForm.get('ddlServiceCenter').markAsTouched()">
                                    </ng-select>
                                    <div *ngIf="(isFormSubmitted || assetForm.get('ddlServiceCenter').touched) && assetForm.get('ddlServiceCenter').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="assetForm.get('ddlServiceCenter').errors.required">Service
                                            Center is
                                            Required</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- vehicle form -->
                    <div *ngIf="isVehicle">
                            <form [formGroup]="vehicleForm" (ngSubmit)="isUpdate ? updateVehicle() : addVehicle()" (keydown.enter)="useEnterKey ? $event.preventDefault() : (isUpdate ? updateVehicle() : addVehicle())">
                                <div class="card">
                                <div class="card-header bg-transparent border-bottom text-uppercase">Additional Info</div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-3">
                                            <div class="mb-2">
                                                <label for="vehicleCode" class="form-label">Vehicle No<span
                                                        class="mandatory">*</span></label>
                                                <input #vehicleCode type="text" id="vehicleCode" class="form-control form-control-sm"
                                                    formControlName="txtVehicleNumber"
                                                    [ngClass]="{'is-invalid': (isFormSubmitted || vehicleForm.get('txtVehicleNumber').touched) && vehicleForm.get('txtVehicleNumber').errors}"
                                                    (keydown.enter)="useEnterKey && assetForm.get('txtVehicleNumber').valid ? vehicleType.focus() : assetForm.get('txtVehicleNumber').markAsTouched()">
                                                <div *ngIf="(isFormSubmitted || vehicleForm.get('txtVehicleNumber').touched) && vehicleForm.get('txtVehicleNumber').errors"
                                                    class="invalid-feedback">
                                                    <span *ngIf="vehicleForm.get('txtVehicleNumber').errors.required">
                                                        Code is
                                                        Required</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-3">
                                            <div class="mb-2">
                                                <label for="vehicleType" class="form-label">Vehicle Type<span
                                                        class="mandatory">*</span></label>
                                                <ng-select id="vehicleType" #vehicleType [items]="typeList" bindLabel="name"
                                                    placeholder="Select" [bindValue]="'id'" [appendTo]="'body'" [openOnEnter]="false"
                                                    formControlName="ddlVehicleType"
                                                    class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                                                    [ngClass]="{'is-invalid': (isFormSubmitted || vehicleForm.get('ddlVehicleType').touched) && vehicleForm.get('ddlVehicleType').errors}"
                                                    (keydown.enter)="useEnterKey && assetForm.get('ddlVehicleType').valid ? vehicleOwner.focus() : assetForm.get('ddlVehicleType').markAsTouched()">
                                                </ng-select>
                                                <div *ngIf="(isFormSubmitted || vehicleForm.get('ddlVehicleType').touched) && vehicleForm.get('ddlVehicleType').errors"
                                                    class="invalid-feedback">
                                                    <span *ngIf="vehicleForm.get('ddlVehicleType').errors.required">Vehicle Type
                                                        is
                                                        Required</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-3">
                                            <div class="mb-2">
                                                <label for="vehicleOwner" class="form-label">Owner<span
                                                        class="mandatory">*</span></label>
                                                <ng-select id="vehicleOwner" #vehicleOwner [items]="ownerList" bindLabel="name"
                                                    placeholder="Select" [bindValue]="'id'" [appendTo]="'body'" [openOnEnter]="false"
                                                    formControlName="ddlVehicleOwner"
                                                    class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                                                    [ngClass]="{'is-invalid': (isFormSubmitted || vehicleForm.get('ddlVehicleOwner').touched) && vehicleForm.get('ddlVehicleOwner').errors}"
                                                    (keydown.enter)="useEnterKey && assetForm.get('ddlVehicleOwner').valid ? status.focus() : assetForm.get('ddlVehicleOwner').markAsTouched()">
                                                </ng-select>
                                                <div *ngIf="(isFormSubmitted || vehicleForm.get('ddlVehicleOwner').touched) && vehicleForm.get('ddlVehicleOwner').errors"
                                                    class="invalid-feedback">
                                                    <span *ngIf="vehicleForm.get('ddlVehicleOwner').errors.required">Owner is Required</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-1">
                                            <div class="mb-2">
                                                <label for="SwitchCheckSizemd" class="form-label">Status</label>
                                                <div class="form-check form-switch form-switch-md">
                                                    <input #status type="checkbox" id="SwitchCheckSizemd" class="form-check-input" formControlName="checkBoxStatus" 
                                                        (keydown.enter)="useEnterKey && chasisNumber.focus()">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                </div>

                                <div class="card">
                                    <div class="card-header bg-transparent border-bottom text-uppercase">Vehicle Info
                                    </div>
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-md-3">
                                                <div class="mb-2">
                                                    <label for="chasisNumber" class="form-label">Chasis Number</label>
                                                    <input #chasisNumber type="text" id="chasisNumber" class="form-control form-control-sm" formControlName="txtChasisNumber" 
                                                        (keydown.enter)="useEnterKey && assetForm.get('txtChasisNumber').valid ? engineNumber.focus() : assetForm.get('txtChasisNumber').markAsTouched()">
                                                </div>
                                            </div>

                                            <div class="col-md-3">
                                                <div class="mb-2">
                                                    <label for="engineNumber" class="form-label">Engine Number</label>
                                                    <input #engineNumber type="text" id="engineNumber" class="form-control form-control-sm" formControlName="txtEngineNumber" 
                                                        (keydown.enter)="useEnterKey && assetForm.get('txtEngineNumber').valid ? vehicleCapacity.focus() : assetForm.get('txtEngineNumber').markAsTouched()">
                                                </div>
                                            </div>

                                            <div class="col-md-3">
                                                <div class="mb-2">
                                                    <label for="vehicleCapacity" class="form-label">Vehicle Capacity (Kgs)</label>
                                                    <input #vehicleCapacity type="number" id="vehicleCapacity" class="form-control form-control-sm" formControlName="txtVehicleCapacity" 
                                                    (keydown.enter)="useEnterKey && assetForm.get('txtVehicleCapacity').valid ? submitBtn.focus() : assetForm.get('txtVehicleCapacity').markAsTouched()">
                                                </div>
                                            </div>                                 
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="card-body">
                                        <div class="col-12 mb-4">
                                            <div class="button-items">
                                                <button #submitBtn type="submit" class="btn btn-primary w-sm" (keydown.enter)="isUpdate ? updateVehicle() : addVehicle()">{{ isUpdate ? 'Update' : 'Add' }}</button>
                                                <button type="button" class="btn btn-secondary w-sm" (click)="resetForm()">Cancel</button>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                        </form>
                    </div>
                    <!-- Driver form -->
                    <div *ngIf="isDriver">
                        <form [formGroup]="driverForm" (ngSubmit)="isUpdate ? updateDriver() : addDriver()" (keydown.enter)="useEnterKey ? $event.preventDefault() : (isUpdate ? updateDriver() : addDriver())">
                            <div class="card">
                                <div class="card-header bg-transparent border-bottom text-uppercase">Additional Info
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-3">
                                            <div class="mb-2">
                                                <label for="driverName" class="form-label">Driver Name<span
                                                        class="mandatory">*</span></label>
                                                <input #driverName type="text" id="driverName" class="form-control form-control-sm" formControlName="txtDriverName"
                                                    [ngClass]="{'is-invalid': (isFormSubmitted || driverForm.get('txtDriverName').touched) && driverForm.get('txtDriverName').errors}"
                                                    (keydown.enter)="useEnterKey && driverForm.get('txtDriverName').valid ? licenceNumber.focus() : driverForm.get('txtDriverName').markAsTouched()">
                                                <div *ngIf="(isFormSubmitted || driverForm.get('txtDriverName').touched) && driverForm.get('txtDriverName').errors"
                                                    class="invalid-feedback">
                                                    <span *ngIf="driverForm.get('txtDriverName').errors.required">Driver
                                                        Name is
                                                        Required</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-3">
                                            <div class="mb-2">
                                                <label for="licenceNumber" class="form-label">Licence Number</label>
                                                <input #licenceNumber type="text" id="licenceNumber" class="form-control form-control-sm" formControlName="txtLicenceNumber"
                                                (keydown.enter)="useEnterKey && driverForm.get('txtLicenceNumber').valid ? issuedBy.focus() : driverForm.get('txtLicenceNumber').markAsTouched()">
                                            </div>
                                        </div>

                                        <div class="col-md-3">
                                            <div class="mb-2">
                                                <label for="issuedBy" class="form-label">Issued By </label>
                                                <input #issuedBy type="text" id="issuedBy" class="form-control form-control-sm" formControlName="txtissuedBy"
                                                (keydown.enter)="useEnterKey && driverForm.get('txtissuedBy').valid ? issueDate.focus() : driverForm.get('txtissuedBy').markAsTouched()">
                                            </div>
                                        </div>

                                        <div class="col-md-2">
                                            <div class="mb-2">
                                                <label for="dateTime" class="form-label">Issue Date </label>
                                                <input #issueDate type="date" id="dateTime" class="form-control form-control-sm" formControlName="txtIssueDate"
                                                (keydown.enter)="useEnterKey && driverForm.get('txtIssueDate').valid ? validUpTo.focus() : driverForm.get('txtIssueDate').markAsTouched()">
                                            </div>
                                        </div>

                                        <div class="col-md-2">
                                            <div class="mb-2">
                                                <label for="validUpTo" class="form-label"> Valid Up To </label>
                                                <input #validUpTo type="date" id="validUpTo" class="form-control form-control-sm" formControlName="txtValidUpTo" 
                                                (keydown.enter)="useEnterKey && driverForm.get('txtValidUpTo').valid ? address1.focus() : driverForm.get('txtValidUpTo').markAsTouched()">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header bg-transparent border-bottom text-uppercase">Residence Info
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-3">
                                            <div class="mb-2">
                                                <label for="address1" class="form-label">Address 1</label>
                                                <input #address1 type="text" id="address1" class="form-control form-control-sm" formControlName="txtAddress1" 
                                                (keydown.enter)="useEnterKey && driverForm.get('txtAddress1').valid ? address2.focus() : driverForm.get('txtAddress1').markAsTouched()">
                                            </div>
                                        </div>

                                        <div class="col-md-3">
                                            <div class="mb-2">
                                                <label for="address2" class="form-label">Address 2</label>
                                                <input #address2 type="text" id="address2" class="form-control form-control-sm" formControlName="txtAddress2" 
                                                (keydown.enter)="useEnterKey && driverForm.get('txtAddress2').valid ? phoneNo.focus() : driverForm.get('txtAddress2').markAsTouched()">
                                            </div>
                                        </div>

                                        <div class="col-md-3">
                                            <div class="mb-2">
                                                <label for="phoneNo" class="form-label">Mobile No.</label>
                                                <input #phoneNo type="number" id="phoneNo" class="form-control form-control-sm" formControlName="txtPhoneNo"
                                                    [ngClass]="{ 'is-invalid': (isFormSubmitted || driverForm.get('txtPhoneNo').touched) && driverForm.get('txtPhoneNo').errors }" 
                                                    (keydown.enter)="useEnterKey && driverForm.get('txtPhoneNo').valid ? submitBtn.focus() : driverForm.get('txtPhoneNo').markAsTouched()">
                                                <div *ngIf="(isFormSubmitted || driverForm.get('txtPhoneNo').touched) && driverForm.get('txtPhoneNo').errors"
                                                    class="invalid-feedback">
                                                    <span *ngIf="driverForm.get('txtPhoneNo').errors.pattern">Must be of
                                                        10
                                                        Digits.</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="card-body">
                                    <div class="col-12 mb-4">
                                        <div class="button-items">
                                            <button #submitBtn type="submit" class="btn btn-primary w-sm" (keydown.enter)="isUpdate ? updateDriver() : addDriver()">{{ isUpdate ? 'Update' : 'Add' }}</button>
                                            <button type="button" class="btn btn-secondary w-sm" (click)="resetForm()">Cancel</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>

                    <!-- vehicle Owner Form -->
                    <div *ngIf="isVehicleOwner">
                        <form [formGroup]="vehicleOwnerForm" (ngSubmit)="isUpdate ? updateVehicleOwner() : addVehicleOwner()" (keydown.enter)="useEnterKey ? $event.preventDefault() : (isUpdate ? updateVehicleOwner() : addVehicleOwner())">
                            <div class="card">
                                <div class="card-header bg-transparent border-bottom text-uppercase">Additional Info
                                </div>

                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-3">
                                            <div class="mb-2">
                                                <label for="ownerName" class="form-label">Owner Name<span class="mandatory">*</span></label>
                                                <input #ownerName type="text" id="ownerName" class="form-control form-control-sm" formControlName="txtOwnerName"
                                                    [ngClass]="{'is-invalid': (isFormSubmitted || vehicleOwnerForm.get('txtOwnerName').touched) && vehicleOwnerForm.get('txtOwnerName').errors}" 
                                                    (keydown.enter)="useEnterKey && vehicleOwnerForm.get('txtOwnerName').valid ? panNumber.focus() : vehicleOwnerForm.get('txtOwnerName').markAsTouched()">
                                                <div *ngIf="(isFormSubmitted || vehicleOwnerForm.get('txtOwnerName').touched) && vehicleOwnerForm.get('txtOwnerName').errors"
                                                    class="invalid-feedback">
                                                    <span *ngIf="vehicleOwnerForm.get('txtOwnerName').errors.required">
                                                        Owner Name is
                                                        Required</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-3">
                                            <div class="mb-2">
                                                <label for="panNumber" class="form-label">Pan Number<span class="mandatory">*</span></label>
                                                <input #panNumber type="text" id="panNumber" class="form-control form-control-sm" formControlName="txtPanNumber"  maxlength="10"
                                                    [ngClass]="{'is-invalid': (isFormSubmitted || vehicleOwnerForm.get('txtPanNumber').touched) && vehicleOwnerForm.get('txtPanNumber').errors}" 
                                                    (keydown.enter)="useEnterKey && vehicleOwnerForm.get('txtPanNumber').valid ? address1.focus() : vehicleOwnerForm.get('txtPanNumber').markAsTouched()">
                                                    <div *ngIf="(isFormSubmitted || vehicleOwnerForm.get('txtPanNumber').touched) && vehicleOwnerForm.get('txtPanNumber').errors"
                                                    class="invalid-feedback">
                                                    <span *ngIf="vehicleOwnerForm.get('txtPanNumber').errors.required"> Pan No. is Required</span>
                                                        <span *ngIf="vehicleOwnerForm.get('txtPanNumber').errors.pattern">Invalid Pan No. format</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header bg-transparent border-bottom text-uppercase">Residence Info
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-3">
                                            <div class="mb-2">
                                                <label for="address1" class="form-label">Address 1</label>
                                                <input #address1 type="text" id="address1" class="form-control form-control-sm" formControlName="txtAddress1" 
                                                    (keydown.enter)="useEnterKey && vehicleOwnerForm.get('txtAddress1').valid ? address2.focus() : vehicleOwnerForm.get('txtAddress1').markAsTouched()">
                                            </div>
                                        </div>

                                        <div class="col-md-3">
                                            <div class="mb-2">
                                                <label for="address2" class="form-label">Address 2</label>
                                                <input #address2 type="text" id="address2" class="form-control form-control-sm" formControlName="txtAddress2" 
                                                    (keydown.enter)="useEnterKey && vehicleOwnerForm.get('txtAddress2').valid ? phoneNo.focus() : vehicleOwnerForm.get('txtAddress2').markAsTouched()">
                                            </div>
                                        </div>

                                        <div class="col-md-3">
                                            <div class="mb-2">
                                                <label for="phoneNo" class="form-label">Mobile No.</label>
                                                <input #phoneNo type="number" id="phoneNo" class="form-control form-control-sm" formControlName="txtPhoneNo"
                                                    [ngClass]="{ 'is-invalid': (isFormSubmitted || vehicleOwnerForm.get('txtPhoneNo').touched) && vehicleOwnerForm.get('txtPhoneNo').errors }" 
                                                    (keydown.enter)="useEnterKey && vehicleOwnerForm.get('txtPhoneNo').valid ? submitBtn.focus() : vehicleOwnerForm.get('txtPhoneNo').markAsTouched()">
                                                <div *ngIf="(isFormSubmitted || vehicleOwnerForm.get('txtPhoneNo').touched) && vehicleOwnerForm.get('txtPhoneNo').errors"
                                                    class="invalid-feedback">
                                                    <span *ngIf="vehicleOwnerForm.get('txtPhoneNo').errors.pattern">Must
                                                        be of 10 Digits.</span>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="card-body">
                                    <div class="col-12 mb-4">
                                        <div class="button-items">
                                            <button #submitBtn type="submit" class="btn btn-primary w-sm" (keydown.enter)="isUpdate ? updateVehicleOwner() : addVehicleOwner()">{{ isUpdate ? 'Update' : 'Add' }}</button>
                                            <button type="button" class="btn btn-secondary w-sm" (click)="resetForm()">Cancel</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <ul ngbNav #justifiednav="ngbNav" [activeId]="isActiveTab" class="nav-pills bg-light rounded nav">
                    <li [ngbNavItem]="1">
                        <a ngbNavLink (click)="isAssetsTabActive = false">
                            <span class="d-block d-sm-none"><i class="fas fa-gear"></i></span>
                            <span class="d-none d-sm-block">Owner</span>
                        </a>
                        <ng-template ngbNavContent>
                            <ng-template [ngTemplateOutlet]="OwnerContent"></ng-template>
                        </ng-template>
                    </li>
                    <li [ngbNavItem]="2">
                        <a ngbNavLink (click)="isAssetsTabActive = true">
                            <span class="d-block d-sm-none"><i class="fas fa-home"></i></span>
                            <span class="d-none d-sm-block">Vehicle</span>
                        </a>
                        <ng-template ngbNavContent>
                            <ng-template [ngTemplateOutlet]="VehicleContent"></ng-template>
                        </ng-template>
                    </li>
                    
                    <li [ngbNavItem]="3">
                        <a ngbNavLink (click)="isAssetsTabActive = false">
                            <span class="d-block d-sm-none"><i class="fas fa-gear"></i></span>
                            <span class="d-none d-sm-block">Driver</span>
                        </a>
                        <ng-template ngbNavContent>
                            <ng-template [ngTemplateOutlet]="DriverContent"></ng-template>
                        </ng-template>
                    </li>
                </ul>
                <div [ngbNavOutlet]="justifiednav"></div>
                <ng-template #VehicleContent>
                    <div class="row">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12 grid-container">
                                    <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="vehicle"
                                        class="ag-theme-balham" [rowData]="vehicleRowData"
                                        [columnDefs]="columnVehicleDefs" [animateRows]="true" [context]="context"
                                        [defaultColDef]="defaultColDef" [gridOptions]="gridOptions" [pagination]="true"
                                        (gridReady)="onGridReady($event)">
                                    </ag-grid-angular>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>

                <ng-template #OwnerContent>
                    <div class="row">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12 grid-container">
                                    <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid"
                                        class="ag-theme-balham" [rowData]="ownerRowData" [columnDefs]="columnOwnerDefs"
                                        [animateRows]="true" [context]="context" [defaultColDef]="defaultColDef"
                                        [gridOptions]="gridOptions" [pagination]="true"
                                        (gridReady)="onGridReady($event)">
                                    </ag-grid-angular>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
                <ng-template #DriverContent>
                    <div class="row">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12 grid-container">
                                    <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid"
                                        class="ag-theme-balham" [rowData]="driverRowData"
                                        [columnDefs]="columnDriverDefs" [animateRows]="true" [context]="context"
                                        [defaultColDef]="defaultColDef" [gridOptions]="gridOptions" [pagination]="true"
                                        (gridReady)="onGridReady($event)">
                                    </ag-grid-angular>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>
<!-- <div class="card">
    <div class="card-header bg-transparent border-bottom text-uppercase"> List </div>
    <div class="card-body">
        <div class="row">
            <div class="col-md-12 grid-container">
                <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid"
                    class="ag-theme-balham" [rowData]="rowData" [columnDefs]="columnDefs"
                    [animateRows]="true" [context]="context" [defaultColDef]="defaultColDef"
                    [gridOptions]="gridOptions" [pagination]="true" (gridReady)="onGridReady($event)">
                </ag-grid-angular>
            </div>
        </div>
    </div>
</div> -->

</ng-container>
<ng-container *ngIf="!permConfig.isViewAllowed">
    <app-forbidden></app-forbidden>
</ng-container>